module.exports = __webpack_public_path__ + "img/Dantam Makeover 17.743d872f.jpg";